/**
 * @author Fernando Ruano
 * @file App.jss
 * @description App Main File
 */

// Dependencies
import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd';
import { BrowserRouter as Router, useHistory } from 'react-router-dom';
import { Security } from '@okta/okta-react';
import { OktaAuth } from '@okta/okta-auth-js';

// Ant languages
import es from 'antd/lib/locale/es_ES';
// import en from 'antd/lib/locale/en_US';

// Containers
import AppContainer from '@nephro/containers/App';

// Hocs
import LaunchMessageProvider from '@nephro/hocs/launchMessageProvider';

// Redux Store
import store from '@nephro/redux/store';

// Okta
const oktaAuth = new OktaAuth({
  clientId: window.env_file.REACT_APP_OKTA_CLIENT_ID_STAFF,
  issuer: window.env_file.REACT_APP_OKTA_ISSUER_STAFF,
  redirectUri: `${window.location.origin}/authorization-code/callback`,
  logoutUrl: `${window.location.origin}/loginStaff`
});

function App() {
  const history = useHistory();
  const restoreOriginalUri = () => {
    history?.replace('/loginStaff');
  };
  const onAuthRequired = () => {
    history?.replace('/loginStaff');
  };

  return (
    <Provider store={store}>
      <Router>
        <Security
          oktaAuth={oktaAuth}
          restoreOriginalUri={restoreOriginalUri}
          onAuthRequired={onAuthRequired}>
          <LaunchMessageProvider>
            <ConfigProvider locale={es}>
              <AppContainer />
            </ConfigProvider>
          </LaunchMessageProvider>
        </Security>
      </Router>
    </Provider>
  );
}

export default App;
